import { configureModal } from '@grapes-agency/ui'

import classes from './Modal.module.scss'

export const Modal = configureModal({ classes })
